const fetchSmartDodosSsoLink: any = async (returnTo: string = "/dashboard") => {
  const { data, status, error }: any = await dataFetch("/smartdodos/sso-link", {
    params: {
      return_to: returnTo,
    },
  });

  if (status.value === "error") {
    return {
      data: null,
      status,
      error: error.value,
    };
  }

  return {
    data: data.value,
    status,
    error: null,
  };
};

// Mint an SSO link and open the SmartDodos dashboard in a new tab.
// The tab is opened synchronously (within the click gesture) so popup blockers
// don't block it, then redirected once the signed link is returned.
const openSmartDodosDashboard: any = async (returnTo: string = "/dashboard") => {
  const newTab = window.open("", "_blank");

  const response = await fetchSmartDodosSsoLink(returnTo);

  if (response.error || !response.data?.redirect_url) {
    if (newTab) newTab.close();
    return { success: false, error: response.error };
  }

  if (newTab) {
    newTab.location.href = response.data.redirect_url;
  } else {
    window.open(response.data.redirect_url, "_blank");
  }

  return { success: true, error: null };
};

export { fetchSmartDodosSsoLink, openSmartDodosDashboard };
